import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import * as he from 'he';
import moment from 'moment';
import {
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import { ApiService } from '../../services/jrni/api.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { MemberService } from '../../services/jrni/member.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AlertService } from '../../_alert';
import { ConfigService } from '../../services/config.service';
import { GovukInitService } from '../../services/govuk-init.service';
import { CommonFunctionsService } from '../../services/common-functions.service';
import { inject } from '@angular/core';
import { postcodeValidator } from "../../validators/postcode.validator";
import { FormBuilderService as LibFormBuilderService, FormBuilderComponent } from '@bookinglab/ui';

@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss'],
})
export class BookingDetailsComponent implements OnInit, AfterViewInit {
  selectedDepartment;
  selectedService;
  pageTitle: string;
  dataPolicy: string;
  tncPolicy: string;
  servicePolicy: string;
  dataPolicyCy: string;
  bookingDetailsPageText: string;
  bookingQuestions = [];
  submitted: boolean;
  selectedLocation;
  requiresFullRegistration = false;
  showBookingQuestions = false;
  organisationQuestions = [];
  today = new Date();
  selectedFile: string;
  selectedId: any;
  subtmitButtonDisabled: boolean;
  addresses = [];
  addressFoundBefore = false;
  member;
  slot;
  banned = false;
  feeItemCache = {};
  customerQuestions;
  unavailableTimes = [];
  currentYear = new Date().getFullYear();
  // https://regexr.com/3pp3r <- Postcode validator
  postcodeValidator = new RegExp(
    '^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2}))$');
  dateId;
  costBreakDown = [];
  companyQuestions = [];
  searchText: string;
  debounceTimer: any;
  adminJourney = false;
  returnConfig: any;
  formData: any = [];
  agentMode: any;
  showFormBuilder = true;
  selectedFormId = '';
  // GRPO-98: custom "Important" box wording for the required document checkboxes
  requiredCheckboxWarningMessage =
    'Please ensure you read and understand the information above and only tick the boxes if you are able to bring the relevant documents. If you tick the boxes and do not have the relevant documents at the time of your appointment, then it will not go ahead and you will be charged again. Please contact us on 0345 045 1363 for advice and to discuss your documents prior to booking your appointment.';

  @ViewChild('password') passwordCtrl!: ElementRef;

  // SUP-2485: schema form ref so onSubmit() can enforce its required fields.
  @ViewChild(FormBuilderComponent) formBuilderRef?: FormBuilderComponent;

  steps = [
    { title: 'Booking questions', isActive: false },
    { title: 'Choose appointment date and time', isActive: false },
    { title: 'Your details', isActive: true },
    { title: 'Summary', isActive: false },
    { title: 'Confirmation', isActive: false },
  ];

  // Initialise the customer form
  customerDetailsForm: UntypedFormGroup = new UntypedFormGroup({
    first_name: new UntypedFormControl('', Validators.required),
    last_name: new UntypedFormControl('', Validators.required),
    email_address: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i),
    ]),
    email_address_consent: new UntypedFormControl('', Validators.requiredTrue),
    contact_number: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(9),
      Validators.maxLength(15),
      Validators.pattern(/[0-9]/),
    ]),
    contact_number_consent: new UntypedFormControl('', Validators.requiredTrue),
    // postcode: new FormControl(""),
    // selectedAddress: new FormControl(""),
    // data_policy: new UntypedFormControl('', Validators.requiredTrue),
    // tnc: new UntypedFormControl('', Validators.requiredTrue),
    // service_policy: new UntypedFormControl('', Validators.requiredTrue),
    dob_day: new UntypedFormControl(false, [
      Validators.required,
      Validators.min(1),
      Validators.max(31),
    ]),
    dob_month: new UntypedFormControl(false, [
      Validators.required,
      Validators.min(1),
      Validators.max(12),
    ]),
    dob_year: new UntypedFormControl(false, Validators.required),
    // password: new UntypedFormControl(""),
    copyData: new UntypedFormControl('No'),
    // confirm_password: new FormControl('', [Validators.required, confirmPasswordValidator]),
  });
  config: any;

  formBuilder: UntypedFormBuilder = inject(UntypedFormBuilder);
  libFormBuilderService = inject(LibFormBuilderService);
  constructor(
    private router: Router,
    private servicesService: ServicesService,
    private departmentService: DepartmentService,
    private basketservice: BasketService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private memberService: MemberService,
    public datastoreService: DatastoreService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private availabilityService: AvailabilityService,
    private configService: ConfigService,
    public translate: TranslateService,
    private govuk: GovukInitService,
    public commonFunctions: CommonFunctionsService
  ) {
    this.appConfig = this.apiService.getAppConfig();
  }

  appConfig: any;

  companyQuestionsForm: UntypedFormGroup = this.formBuilder.group({});
  bookingQuestionsForm: UntypedFormGroup = this.formBuilder.group({});

  pad(num: number, size: number): string {
    let s = num + '';
    while (s.length < size) s = '0' + s;
    return s;
  }

  get form() {
    return this.customerDetailsForm.controls;
  }

  get bookingForm() {
    return this.companyQuestionsForm.controls;
  }

  formReady($event: Record<string, any>) {
    console.log('Form ready event received in BookingDetailsComponent:', $event);
    if ($event.form_id === this.selectedFormId) {
      console.log('Extra items after form ready event:', $event.extra_items);
      const fees = $event.extra_items;
      console.log('Adding extra item fees from form ready event:', this.datastoreService.serviceFees);
      if (!this.datastoreService.serviceFees) {
        this.datastoreService.serviceFees = [];
      }
      console.log(this.datastoreService._extraItems);
      for (const fee of this.datastoreService._extraItems) {
        const found = this.datastoreService.serviceFees.findIndex((item: any) => item.questionid === fee.field);
        if (found === -1) {
          this.datastoreService.serviceFees.push({
            questionid: fee.field,
            item: fee.item_name,
            quantity: fee.qty,
            cost: fee.item_price,
            item_id: fee.item_id,
          });
        }
      }
      console.log('Updated service fees in datastore:', this.datastoreService.serviceFees);
    }
  }

  onFormProcessing(isProcessing: boolean) {
    console.log('Form processing state:', isProcessing);
    if (isProcessing) {
      this.spinner.show();
    } else {
      this.spinner.hide();
    }
  }


  async onExtraItemSet($event: Record<string, any>) {
    console.log(`Extra item set event received in BookingDetailsComponent: `, $event);
    if ($event.item) {
      console.log(`Adding extra item fee for extra item: `, $event.item);
      // Remove any stale fee for the same field (e.g. switching between together/separately)
      // before adding the new one, so _extraItems never accumulates duplicates.
      const staleIdx = this.datastoreService._extraItems.findIndex(
        (item: any) => item.field === $event.item.field
      );
      if (staleIdx !== -1) {
        this.datastoreService._extraItems.splice(staleIdx, 1);
      }
      this.datastoreService._extraItems.push($event.item);
      this.costBreakDown.push({
        questionid: $event.item.field,
        item: $event.item.item_name,
        quantity: $event.item.qty,
        cost: $event.item.item_price,
      });
      this.datastoreService.triggerAddFees({
        questionid: $event.item.field,
        item: $event.item.item_name,
        quantity: $event.item.qty,
        cost: $event.item.item_price,
        item_id: $event.item.item_id,
      });
    }
    else {
      // Item was deselected (quantity set to 0) — remove it from tracked items and fees.
      // Prefer matching by field name (always set on _extraItems entries) since the API
      // numeric item_id won't match the schema key string in $event.item_id.
      const fieldName = $event.field;
      const itemId = $event.item_id;
      const extraIdx = fieldName
        ? this.datastoreService._extraItems.findIndex((item: any) => item.field === fieldName)
        : this.datastoreService._extraItems.findIndex((item: any) => String(item.item_id) === String(itemId));
      if (extraIdx !== -1) {
        this.datastoreService._extraItems.splice(extraIdx, 1);
      }
      if (this.datastoreService.serviceFees) {
        const feeEntry = fieldName
          ? this.datastoreService.serviceFees.find((item: any) => item.questionid === fieldName)
          : this.datastoreService.serviceFees.find((item: any) => item.item_id === itemId);
        if (feeEntry) {
          this.datastoreService.triggerAddFees({
            questionid: feeEntry.questionid,
            item: feeEntry.item,
            quantity: 0,
            cost: 0,
            item_id: feeEntry.item_id,
          });
        }
      }
    }
    console.log('this.datastoreService._extraItems', this.datastoreService._extraItems);
    console.log('this.datastoreService.serviceFees', this.datastoreService.serviceFees);
    console.log('this.costBreakDown', this.costBreakDown);
  }

  async onExtraItemChanged($event: Record<string, any>) {
    console.log(`Extra item changed event received in BookingDetailsComponent: `, $event);
    if ($event.item) {
      // find extra item
      const foundIndex = this.datastoreService._extraItems.findIndex((item: any) => item.item_id === $event.item_id);
      console.log('foundIndex', foundIndex);
      // remove it
      if (foundIndex !== -1) {
        this.datastoreService._extraItems.splice(foundIndex, 1);
        // re-add it
        this.datastoreService._extraItems.push($event.item);
        this.costBreakDown.push({
          questionid: $event.item.field,
          item: $event.item.item_name,
          quantity: $event.item.qty,
          cost: $event.item.item_price,
        });
        this.datastoreService.triggerAddFees({
          questionid: $event.item.field,
          item: $event.item.item_name,
          quantity: $event.item.qty,
          cost: $event.item.item_price,
        });
      }

    }
    console.log('this.datastoreService._extraItems', this.datastoreService._extraItems);
    console.log('this.datastoreService.serviceFees', this.datastoreService.serviceFees);
    console.log('this.costBreakDown', this.costBreakDown);
  }

  routerGoBack() {
    this.router.navigate(['/calendar']);
  }

  restartJourney() {
    if (sessionStorage.getItem('journey')) {
      this.router.navigate(['start/' + sessionStorage.getItem('journey')])
    }
    else {
      this.router.navigate(['/departments']);
    }
  }

  forceRecreateFormBuilder() {
    this.showFormBuilder = false;
    setTimeout(() => (this.showFormBuilder = true));
  }

  ngOnInit() {
    this.libFormBuilderService.processing$.subscribe((isProcessing) => {
      if (isProcessing) {
        this.spinner.show();
      } else {
        this.spinner.hide();
      }
    });

    this.selectedFormId = this.datastoreService.selectedSchema;
    if (this.basketservice.currentServiceItem?.resource_id) {
      this.libFormBuilderService.setFormResourceId(this.selectedFormId, String(this.basketservice.currentServiceItem.resource_id));
    }
    this.govuk.init();
    this.scrollToTop();
    console.log('admin', this.datastoreService.adminJourney);
    if (!this.datastoreService.adminJourney) {
      this.adminJourney = false;
      // this.customerDetailsForm.controls['password'].setValidators([Validators.required, passwordValidator]);
      // console.log(this.customerDetailsForm.controls['password']);
    } else {
      this.adminJourney = true;
    }

    this.returnConfig = this.datastoreService.config.journey_config.appointments.returnHomeButtonLink;
    this.agentMode = localStorage.getItem('agent');

    // restore the costbreakdown from datastore
    console.log('Restoring service fees:', this.datastoreService.serviceFees);
    if (this.datastoreService.serviceFees) {
      this.costBreakDown = this.datastoreService.serviceFees;
    } else {
      this.costBreakDown = []; // clear cost breakdown; in future if we add to this more we dont want to clear but replace
    }

    this.availabilityService.getSelectedSlot().then((slot) => {
      if (slot) {
        this.slot = slot;
      }
    });
    this.departmentService.get().then(async (selectedDepartment) => {
      this.config = await this.apiService.getConfig();
      if (selectedDepartment === undefined) {
        this.restartJourney();
      } else {
        this.spinner.show();
        this.selectedDepartment = selectedDepartment;

        let registrationOption = '';
        let organisationQuestionsID;

        // Set the title on the login page to the title from the business question
        this.selectedDepartment.extra?.hasOwnProperty(
          'booking_details_page_title'
        )
          ? (this.pageTitle =
            this.selectedDepartment.extra.booking_details_page_title)
          : (this.pageTitle = 'Booking details title not set');

        // Get the configurable data
        if (this.selectedDepartment.hasOwnProperty('extra')) {
          // Set the extra text on the page to the text taken from the business question

          if (this.adminJourney) {
            this.dataPolicy = `Advise the customer that they can see our Privacy Policy for details on how the council processes their information. They can find the policy <a href="/tbc" target="_blank">here</a>.`;
          } else {
            this.selectedDepartment.extra.hasOwnProperty(
              'privacy_statement_text'
            )
              ? (this.dataPolicy =
                this.selectedDepartment.extra.privacy_statement_text)
              : (this.dataPolicy = 'data policy not set');

            this.selectedDepartment.extra.hasOwnProperty(
              'privacy_statement_text_welsh'
            )
              ? (this.dataPolicyCy =
                this.selectedDepartment.extra.privacy_statement_text_welsh)
              : (this.dataPolicyCy = 'Welsh data policy not set');
          }

          if (this.adminJourney) {
            this.tncPolicy =
              'Registration information is retained indefinitely as required by law. Information collected during the booking of appointments and ceremonies, including certificate orders, is retained for 2 years from the date of the appointment or ceremony.';
          } else {
            this.tncPolicy =
              'Registration information is retained indefinitely as required by law. Information collected during the booking of appointments and ceremonies, including certificate orders, is retained for 2 years from the date of the appointment or ceremony.';
          }

          if (this.adminJourney) {
            this.servicePolicy =
              "The Terms and Conditions are available at: <a href='http://www.essex.gov.uk/marriage-or-civil-partnership'>http://www.essex.gov.uk/marriage-or-civil-partnership</a> .  They will also be included in the booking email that will be sent to the customer after the booking process has been completed.  ";
          } else {
            this.servicePolicy =
              "Please read the Essex Registration Service <a href='https://res.cloudinary.com/bookinglab/image/upload/v1742564813/Ceremony_-_Terms_and_Conditions_k5a0j7.pdf' target='_blank'>Terms and Conditions</a> and confirm you agree.";
          }

          this.selectedDepartment.extra.hasOwnProperty(
            'booking_details_page_text'
          )
            ? (this.bookingDetailsPageText =
              this.selectedDepartment.extra.booking_details_page_text)
            : null;

          // Set the extra text on the page to the text taken from the business question
          this.selectedDepartment.extra.hasOwnProperty(
            'booking_details_page_text'
          )
            ? (this.bookingDetailsPageText =
              this.selectedDepartment.extra.booking_details_page_text)
            : null;
          // Get the registration option
          this.selectedDepartment.extra.hasOwnProperty('registration_option')
            ? (registrationOption =
              this.selectedDepartment.extra.registration_option)
            : null;
          // Get the organistion customer questions
          this.selectedDepartment.extra.hasOwnProperty(
            'organisations_questions'
          )
            ? (organisationQuestionsID =
              this.selectedDepartment.extra.organisations_questions)
            : null;

          // If the register option is set to complete a full registration then capture the following details
          if (
            registrationOption.toLowerCase() === 'register complete details'
          ) {
            this.requiresFullRegistration = true;
          }
        }

        // Auto-fill contact details from booker data (set by form-builder on services page)
        if (this.datastoreService.booker_first_name) {
          this.customerDetailsForm.controls['first_name'].setValue(this.datastoreService.booker_first_name);
        }
        if (this.datastoreService.booker_last_name) {
          this.customerDetailsForm.controls['last_name'].setValue(this.datastoreService.booker_last_name);
        }
        if (this.datastoreService.booker_email) {
          this.customerDetailsForm.controls['email_address'].setValue(this.datastoreService.booker_email);
        }
        if (this.datastoreService.booker_phone) {
          this.customerDetailsForm.controls['contact_number'].setValue(this.datastoreService.booker_phone);
        }

        // refill customer details on coming back
        if (this.datastoreService.customerDetailsForm) {
          Object.keys(
            this.datastoreService.customerDetailsForm.controls
          ).forEach((key) => {
            if (this.customerDetailsForm.controls[key]) {
              this.customerDetailsForm.controls[key].setValue(
                this.datastoreService.customerDetailsForm.controls[key].value
              );
            }
          });
        }

        // Use this.departmentService.getLocation() if the services are set on the children departments
        // Use this.departmentService.get() if the services are set on the parent department
        this.departmentService.getLocation().then(async (location) => {
          this.selectedLocation = location;

          // Delete any exisitng baskets to avoid conflicts
          // if (this.basketservice.currentBasket) {
          //   await this.basketservice.delete(
          //     this.selectedLocation,
          //     this.basketservice.currentBasket
          //   );
          // }
          this.memberService.getMember().then((member) => {
            this.member = member;

            // Get the customer questions
            this.departmentService
              .getCustomerQuestions()
              .then((questions) => {
                const filteredQuestions = [];
                for (let index = 0; index < questions.length; index++) {
                  const question = this.customerQuestions[index];
                  filteredQuestions.push(question);
                  question.visible = false;
                  question.reference = question.id;
                  if (!question.admin_only) {
                    if (
                      !question.settings.hasOwnProperty(
                        'conditional_question'
                      )
                    ) {
                      question.visible = true;
                    }

                    const questionControl = question.id;
                    if (
                      question.detail_type == 'check' ||
                      question.detail_type == 'check-price'
                    ) {
                      if (question.default == 1) {
                        if (question.required) {
                          this.customerDetailsForm.addControl(
                            questionControl,
                            new UntypedFormControl(
                              true,
                              Validators.requiredTrue
                            )
                          );
                        } else {
                          this.customerDetailsForm.addControl(
                            questionControl,
                            new UntypedFormControl(true)
                          );
                        }
                      } else {
                        if (question.required) {
                          this.customerDetailsForm.addControl(
                            questionControl,
                            new UntypedFormControl(
                              '',
                              Validators.requiredTrue
                            )
                          );
                        } else {
                          this.customerDetailsForm.addControl(
                            questionControl,
                            new UntypedFormControl(false)
                          );
                        }
                      }
                    } else {
                      // Need to add the control for display purposes but we don't need to validate it as we've added three new controls.
                      if (
                        question.id !== 1 &&
                        question.id !== 279 &&
                        question.id !== 34
                      ) {
                        if (question.required) {
                          this.customerDetailsForm.addControl(
                            questionControl,
                            new UntypedFormControl('', Validators.required)
                          );
                        } else {
                          this.customerDetailsForm.addControl(
                            questionControl,
                            new UntypedFormControl('')
                          );
                        }
                      } else {
                        this.customerDetailsForm.addControl(
                          questionControl,
                          new UntypedFormControl('')
                        );
                      }
                    }
                  }
                  // }
                }
                this.customerQuestions = filteredQuestions;
                this.datastoreService.customerQuestions = filteredQuestions;
                this.dateId = '';
                // id of date question is one of these, but we don't know which
                if (this.customerDetailsForm.get('1') !== undefined)
                  this.dateId = '1';
                if (this.customerDetailsForm.get('279') !== undefined)
                  this.dateId = '279';
                if (this.customerDetailsForm.get('34') !== undefined)
                  this.dateId = '34';
              });
          });
        });

        // Get the selected service
        this.servicesService.get().then(async (service) => {
          this.selectedService = service;
          console.log(`selected service`, this.selectedService);
          // Get the questions
          // const res = await this.selectedService.$get('questions');
          // this.datastoreService.bookingQuestions = res.questions;
          // console.log(res.questions);
          // this.addQuestionsToForm(res.questions);
          this.spinner.hide();
          // const questions = []
          // const sortedQuestions = res.questions;
          // for (let index = 0; index < res.questions.length; index++) {
          //   // ignore the previously asked questions
          //   const question = sortedQuestions[index];
          //   if ((this.config['first_page_questions_to_ignore'].includes(question.id))) {
          //     questions.push(question)
          //     if (![275, 276, 277, 278].includes(question.id)) {
          //       question.visible = false;
          //       question.reference = question.id;
          //       if (!question.admin_only) {
          //         if (!question.settings.hasOwnProperty("conditional_question")) {
          //           question.visible = true;
          //         }
          //         const questionControl = question.id;

          //         if (question.detail_type == 'check' || question.detail_type == 'check-price') {
          //           if (question.required) {
          //             this.bookingQuestionsForm.addControl(questionControl, new FormControl(false, Validators.requiredTrue));
          //           } else {
          //             this.bookingQuestionsForm.addControl(questionControl, new FormControl(false));
          //           }
          //         } else {
          //           if (question.required) {
          //             this.bookingQuestionsForm.addControl(questionControl, new FormControl('', Validators.required));
          //           } else {
          //             this.bookingQuestionsForm.addControl(questionControl, new FormControl(''));
          //           }
          //         }
          //       }
          //     }
          //   }
          // }
        });
      }
    });
  }

  ngAfterViewInit(): void {
    // new PasswordInput(this.passwordCtrl.nativeElement);
  }

  async radioCopyChange() {
    const status = this.customerDetailsForm.value.copyData;
    if (this.datastoreService.config.journey_config.copyClientDetails) {
      const copyClientDetails =
        this.datastoreService.config.journey_config.copyClientDetails;
      if (status === 'Yes') {
        for (let i in copyClientDetails.from) {
          this.companyQuestionsForm.controls[
            copyClientDetails.to[i].toString()
          ].setValue(this.customerDetailsForm.value[copyClientDetails.from[i]]);
        }
      } else {
        for (let i in copyClientDetails.to) {
          this.companyQuestionsForm.controls[
            copyClientDetails.to[i].toString()
          ]?.setValue('');
        }
      }
    }
  }

  // addHyperlinks(question) {
  //   let linkPattern = /#(.*?)#/g;
  //   if (linkPattern.test(question.conditionals.component_text)) {
  //     // replace the #link# with a hyperlink
  //     question.conditionals.component_text =
  //       question.conditionals.component_text.replace(
  //         linkPattern,
  //         function (match, p1) {
  //           return (
  //             `<a href="${question.conditionals.hyperlink}" target="_blank">` +
  //             p1 +
  //             '</a>'
  //           );
  //         }
  //       );
  //   }
  //   return question.conditionals.component_text;
  // }

  decodeHtmlEntities(text) {
    const entities = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'"
    };
    return text.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, match => entities[match]);
  }

  addHyperlinks(text: string): string {
    return text.replace(/~(.*?)~/g, (match, p1) => {
      const decoded = this.decodeHtmlEntities(p1);
      return `<a ${decoded}</a>`;
    });
  }

  onQuestionChange() {
    /**
    // this.showServices = false;
    this.datastoreService.extraDuration = 0; // reset or we add more on everytime
    if (!this.companyQuestions) {
      return;
    }
    const bookingQuestions = this.companyQuestions;
    // Conditional questions logic
    // for (let index = 0; index < bookingQuestions.length; index++) {
    bookingQuestions.forEach((bookingQuestion: any) => {
      bookingQuestion.visible = false; // reset any questions that shouldnt be visible
      // go get the answer for every question from the form
      let control = this.companyQuestionsForm.get(`${bookingQuestion.id}`);
      bookingQuestion.answer = undefined;
      if (control) {
        // set booking question from form values
        bookingQuestion.answer = control.value ? control.value : undefined;
      }

      if (bookingQuestion['help_text']) {
        bookingQuestion.conditionals = JSON.parse(bookingQuestion['help_text']); // to change to settings block soon
        if (bookingQuestion.conditionals.hasOwnProperty('help_text')) {
          bookingQuestion.helptext = bookingQuestion.conditionals.help_text;
          let linkPattern = /#(.*?)#/g;
          if (linkPattern.test(bookingQuestion.helptext)) {
            bookingQuestion.helptext = bookingQuestion.helptext.replace(
              linkPattern,
              function (match, p1) {
                return (
                  `<a href="${bookingQuestion.conditionals.hyperlink}" target="_blank">` +
                  p1 +
                  '</a>'
                );
              }
            );
          }

          let tildePattern = /~(.*?)~/g;
          if (tildePattern.test(bookingQuestion.helptext)) {
            bookingQuestion.helptext = bookingQuestion.helptext.replace(
              tildePattern,
              (match, p1) => {
                const decoded = this.decodeHtmlEntities(p1);
                return `<a ${decoded}</a>`;
              }
            );
          }
        }
        if (
          bookingQuestion.conditionals.hasOwnProperty('question-font-colour')
        ) {
          bookingQuestion.customLabelColour =
            bookingQuestion.conditionals['question-font-colour'];
        }
        if (bookingQuestion.conditionals.hasOwnProperty('address_lookup')) {
          if (bookingQuestion.conditionals['address_lookup'] === 'yes') {
            bookingQuestion.address_lookup = true;
          }
        }

        if (
          bookingQuestion.conditionals.hasOwnProperty(
            'address_lookup_multi_line'
          )
        ) {
          bookingQuestion.address_lookup_multi_line = true;
          bookingQuestion.address_lookup_multi_line_to =
            bookingQuestion.conditionals.address_lookup_multi_line.to;
        }
        if (bookingQuestion.conditionals.hasOwnProperty('validation')) {
          if (!this.config.validation) {
            // if there is no validation on the root
            // its probably under the journey_config
            this.config.validation =
              this.config.journey_config?.appointments?.validation;
          }
          if (this.config.validation[bookingQuestion.conditionals.validation]) {
            bookingQuestion.validation =
              this.config.validation[bookingQuestion.conditionals.validation];
            bookingQuestion.validation_message =
              bookingQuestion.conditionals.validation_message;
            let validators = [Validators.pattern(bookingQuestion.validation)];
            if (bookingQuestion.required) {
              validators.push(Validators.required);
            }
            control.setValidators(validators);
            this.companyQuestionsForm.updateValueAndValidity();
          } else {
            if (bookingQuestion.conditionals.validation == 'email') {
              bookingQuestion.validation = 'email';
              bookingQuestion.validation_message =
                bookingQuestion.conditionals.validation_message;
              let validators = [Validators.email];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              control.setValidators(validators);
              this.companyQuestionsForm.updateValueAndValidity();
            }
            if (bookingQuestion.conditionals.validation == 'postcode') {
              bookingQuestion.validation = 'postcode';
              bookingQuestion.validation_message =
                bookingQuestion.conditionals.validation_message;
              let validators = [postcodeValidator()];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              control.setValidators(validators);
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }
        } else {
          if (bookingQuestion.required) {
            control.setValidators(Validators.required);
          }
        }
        if (bookingQuestion.conditionals.hasOwnProperty('section_title')) {
          if (bookingQuestion.conditionals.section_title) {
            bookingQuestion.detail_type = 'heading_2';
          }
        }

        if (bookingQuestion.detail_type === 'date') {
          bookingQuestion.hide_dates_in_future = false;
          bookingQuestion.hide_dates_in_past = false;

          if (
            bookingQuestion.conditionals.hasOwnProperty(
              'hide_dates_in_future'
            ) &&
            bookingQuestion.conditionals.hide_dates_in_future
          ) {
            bookingQuestion.hide_dates_in_future =
              moment().format('YYYY-MM-DD');
            // future date
            if (bookingQuestion.hide_dates_in_future) {
              let validators = [];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              validators.push(this.futureDateValidator);
              control.setValidators(validators);
              control.updateValueAndValidity();
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }

          if (
            bookingQuestion.conditionals.hasOwnProperty('hide_dates_in_past') &&
            bookingQuestion.conditionals.hide_dates_in_past
          ) {
            bookingQuestion.hide_dates_in_past = moment().format('YYYY-MM-DD');

            // past date
            if (bookingQuestion.hide_dates_in_past) {
              let validators = [];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              validators.push(this.pastDateValidator);
              control.setValidators(validators);
              control.updateValueAndValidity();
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }
        }

        const conditionals = bookingQuestion.conditionals;
        let show = conditionals.show;
        const hide = conditionals.hide;
        const admin_show = conditionals.admin_show;
        let admin_only = conditionals.admin_only;

        // if the booking is only for the admin journey
        if (admin_only && this.datastoreService.adminJourney) {
          show = admin_show;
          admin_only = false;
        }

        if (
          Object.keys(show).length === 0 &&
          Object.keys(hide).length === 0 &&
          !conditionals.admin_only
        ) {
          // no hide or show conditional values, just show the question by default
          bookingQuestion.visible = true;
        }

        // show condition loop

        for (const answerId in show) {
          if (answerId == 'hide') {
            return; // this shouldnt happen only if the setup is wrong
          }
          if (answerId === 'custom') {
            const conditions = show[answerId];

            for (const [questionKey, condition] of Object.entries(conditions)) {
              let conditionalQuestion = this.companyQuestionsForm.get(questionKey);
              if (!conditionalQuestion) {
                conditionalQuestion = this.datastoreService.startQuestions.get(
                  `${questionKey}`
                );
              }

              if (
                conditionalQuestion &&
                conditionalQuestion.value != null &&
                ((typeof conditionalQuestion.value === 'string' &&
                  conditionalQuestion.value.trim().length > 0) ||
                  (Array.isArray(conditionalQuestion.value) &&
                    conditionalQuestion.value.length > 0))
              ) {
                const isOrCondition = typeof condition === 'string' && condition.includes('OR');
                const isVisible = isOrCondition
                  ? this.evaluateORCondition(
                    condition,
                    conditionalQuestion.value
                  )
                  : this.evaluateCondition(
                    condition,
                    conditionalQuestion.value
                  );

                if (isVisible) {
                  bookingQuestion.visible = true;
                  break; // stop evaluating once one condition passes
                }
              } else {
                console.log("Conditional question not found or has no value:", questionKey);
              }
            }
          } else if (answerId == 'custom_multiple_condition') {
            // https://bookinglab.atlassian.net/browse/RWRSPI-376
            const conditionSet = show[answerId]?.conditions;

            if (Array.isArray(conditionSet)) {
              let allConditionsMet = true;

              for (const conditionEntry of conditionSet) {
                const [questionKey, expectedValue] = Object.entries(conditionEntry)[0];
                let conditionalQuestion = this.companyQuestionsForm.get(questionKey);
                if (!conditionalQuestion) {
                  conditionalQuestion = this.datastoreService.startQuestions.get(
                    `${questionKey}`
                  );
                }

                const actualValue = conditionalQuestion?.value;

                // does the conditional question have errors
                if (conditionalQuestion?.errors) {
                  console.warn(
                    `Conditional question ${questionKey} has errors:`,
                    conditionalQuestion.errors
                  );
                  allConditionsMet = false;
                  break;
                }

                const isValuePresent =
                  actualValue != null &&
                  ((typeof actualValue === 'string' && actualValue.trim().length > 0) ||
                    (Array.isArray(actualValue) && actualValue.length > 0));

                if (expectedValue === '*') {
                  if (!isValuePresent) {
                    allConditionsMet = false;
                    break;
                  }
                } else {
                  let conditionMet = false;

                  // like 1 OR 2 
                  if (typeof expectedValue === 'string' && expectedValue.includes('OR')) {
                    conditionMet = this.evaluateORCondition(expectedValue, actualValue);
                  } else {
                    // none or condition
                    if (
                      isValuePresent &&
                      ((typeof actualValue === 'string' && actualValue === expectedValue) ||
                        (Array.isArray(actualValue) &&
                          actualValue.includes(expectedValue)))
                    ) {
                      conditionMet = true;
                    }
                  }

                  if (!conditionMet) {
                    allConditionsMet = false;
                    break;
                  }
                }
              }

              if (allConditionsMet) {
                bookingQuestion.visible = true;
              }
            }
          }
          else if (answerId === 'custom_or_condition') {
            // https://bookinglab.atlassian.net/browse/RWRSPI-382
            const conditionSet = show[answerId]?.conditions;

            if (Array.isArray(conditionSet)) {
              for (const conditionEntry of conditionSet) {
                const [questionKey, acceptedAnswers] = Object.entries(
                  conditionEntry
                )[0] as any;

                const conditionalQuestion =
                  this.companyQuestionsForm.get(questionKey);
                const actualValue = conditionalQuestion?.value;

                if (
                  actualValue != null &&
                  ((typeof actualValue === 'string' &&
                    acceptedAnswers.includes(actualValue)) ||
                    (Array.isArray(actualValue) &&
                      actualValue.some((val) => acceptedAnswers.includes(val))))
                ) {
                  console.log(
                    `%cCondition for custom_or_condition met for question ${questionKey} with value: ${actualValue}`,
                    'color: green;'
                  );
                  bookingQuestion.visible = true;
                  break; // One match is enough
                }
              }
            }
          } else if (answerId === 'address') {
            const key = Object.keys(show['address']);
            const conditionalQuestion = this.companyQuestionsForm.get(
              `${key[0]}`
            );

            if (conditionalQuestion && conditionalQuestion.value !== null) {
              // to check if its answered
              // find the key in the this.bookingQuestions array
              const bookingQuestionKey = Number(
                Object.keys(bookingQuestion.conditionals.show.address)[0]
              );
              const currentQuestion = bookingQuestions.findIndex(
                (q) => q.id == bookingQuestionKey
              );
              const addressLookupQuestion = bookingQuestions[currentQuestion];

              if (
                addressLookupQuestion.eligible_address[bookingQuestionKey] ==
                bookingQuestion.conditionals.show.address[bookingQuestionKey]
              ) {
                bookingQuestion.visible = true;
              }
            }
          } else if (answerId === 'custom_all_lookups_successful') {

            // check every lookup question
            const lookupQuestions = bookingQuestions.filter(
              (q) => q.aws_lookup && q.visible
            );

            // if there are no lookup questions, we can skip this
            if (lookupQuestions.length === 0) {
              bookingQuestion.visible = false;
              return;
            }

            // if any of the lookupQuestions contain lookupError = true or lookupUsed = true and all have an answer then bookingQuestion.visible = false
            const allLookupsSuccessful = lookupQuestions.every(
              (q) =>
                !q.lookupError &&
                !q.lookupUsed &&
                q.answer != null &&
                q.answer !== ''
            );

            // do any of the lookup fields have errors?
            const lookupFieldsWithErrors = lookupQuestions.some(
              (q) => this.companyQuestionsForm.get(`${q.id}`).errors
            );

            if (lookupFieldsWithErrors) {
              bookingQuestion.visible = false;
            } else {
              bookingQuestion.visible = true;
            }

            if (allLookupsSuccessful) {
              bookingQuestion.visible = true;
            } else {
              bookingQuestion.visible = false;
            }

          } else {
            // if this is an admin journey, and there is an admin show value
            if (this.datastoreService.adminJourney && admin_show) {
              // if we find a show in both
              if (admin_show[`${answerId}`] && show[`${answerId}`]) {
                // set the show to the admin version as it supersedes show
                show[`${answerId}`] = admin_show[`${answerId}`];
                bookingQuestion.admin_override = true;
              }
            }

            let conditionalQuestion = this.companyQuestionsForm.get(
              `${answerId}`
            );

            if (!conditionalQuestion && show) {
              conditionalQuestion = this.datastoreService.startQuestions.get(
                `${answerId}` // MIGHT NEED TO CHANGE TO ANSWERKEY
              );
            }

            if (conditionalQuestion && conditionalQuestion.value != null) {
              if (
                conditionalQuestion.value ||
                conditionalQuestion.value.length > 0
              ) {
                if (show[answerId].trim() == '*') {
                  // wild card
                  if (
                    conditionalQuestion.value ||
                    conditionalQuestion.value.length > 0
                  ) {
                    // if there is any answer
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          }
        }

        // perform hide after show because we want it to take priority
        for (const answerId in hide) {
          if (answerId == 'show') {
            return; // this shouldnt happen only if the setup is wrong
          }
          if (answerId === 'custom') {
            const conditions = hide[answerId];

            for (const [questionKey, condition] of Object.entries(conditions)) {
              const conditionalQuestion =
                this.companyQuestionsForm.get(questionKey);

              if (
                conditionalQuestion &&
                conditionalQuestion.value != null &&
                ((typeof conditionalQuestion.value === 'string' &&
                  conditionalQuestion.value.trim().length > 0) ||
                  (Array.isArray(conditionalQuestion.value) &&
                    conditionalQuestion.value.length > 0))
              ) {
                const isOrCondition =
                  typeof condition === 'string' && condition.includes('OR');
                const isVisible = isOrCondition
                  ? this.evaluateORCondition(
                    condition,
                    conditionalQuestion.value
                  )
                  : this.evaluateCondition(
                    condition,
                    conditionalQuestion.value
                  );

                if (isVisible) {
                  bookingQuestion.visible = true;
                  break; // stop evaluating once one condition passes
                }
              }
            }
          } else {
            const conditionalQuestion = this.companyQuestionsForm.get(
              `${answerId}`
            );
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if (
                conditionalQuestion.value ||
                conditionalQuestion.value.length > 0
              ) {
                if (show[answerId] == '*') {
                  // wild card
                  if (
                    conditionalQuestion.value ||
                    conditionalQuestion.value.length > 0
                  ) {
                    // if there is any answer
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
                    bookingQuestion.visible = false;
                  }
                }
              }
            }
          }
        }

        // copy question schema
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('copy_data')) {
            bookingQuestion.copy_data_from =
              bookingQuestion.conditionals['copy_data'].from;
            bookingQuestion.copy_data_to =
              bookingQuestion.conditionals['copy_data'].to;
            bookingQuestion.copy_answer =
              bookingQuestion.conditionals['copy_data'].answer;

            if (
              bookingQuestion.answer == true ||
              bookingQuestion.copy_answer == bookingQuestion.answer
            ) {
              bookingQuestion.copy_data_from.forEach((fromId, index) => {
                const toId = bookingQuestion.copy_data_to[index];
                const sourceControl = this.companyQuestionsForm.get(
                  String(fromId)
                );
                const targetControl = this.companyQuestionsForm.get(
                  String(toId)
                );
                if (sourceControl && targetControl) {
                  targetControl.setValue(sourceControl.value);
                } else {
                  console.warn(
                    `Control not found for: ${fromId} or target: ${toId}`
                  );
                }
              });
            }
            // commented out because we cant clear the fields if there is no answer because
            // the field will be cleard everytime the user changes an answer but hasnt filled in the copy question
            // else {
            //   // clear all the copy_data_to fields
            //   bookingQuestion.copy_data_to.forEach((toId) => {
            //     const targetControl = this.companyQuestionsForm.get(String(toId));
            //     if (targetControl) {
            //       targetControl.setValue('');
            //     }
            //   });
            // }
          }
        }

        // add hidden field
        if (bookingQuestion.conditionals.hasOwnProperty('hidden_field')) {
          bookingQuestion.hidden = true;
        }

        // add duration schema
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('add_duration')) {
            this.datastoreService.extraDuration =
              Number(this.datastoreService.extraDuration) +
              Number(bookingQuestion.conditionals.add_duration);
            console.log(`Adding duration from question (${bookingQuestion.id}): ${bookingQuestion.conditionals.add_duration} - total extra is now ${this.datastoreService.extraDuration}`);
          }
        }

        // if (this.datastoreService.appointment_type && 
        //     bookingQuestion.conditionals.appointment_type &&
        //     this.datastoreService.appointment_type === bookingQuestion.conditionals.appointment_type) {
        //   bookingQuestion.visible = true;
        //   console.log(`Showing question (${bookingQuestion.id})`);
        // } else {
        //   bookingQuestion.visible = false;
        //   console.log(`Hiding question (${bookingQuestion.id})`);
        // }

        if (bookingQuestion.conditionals.hasOwnProperty('appointment_type')) {
          if (this.datastoreService.appointment_type !== bookingQuestion.conditionals.appointment_type) {
            bookingQuestion.visible = false;
            console.log(`Hiding question (${bookingQuestion.id}) because appointment_type is ${this.datastoreService.appointment_type}`);
          }
        }

        // set sevice question to var
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('service_set')) {
            this.datastoreService.setService =
              bookingQuestion.conditionals.service_set;
          }
        }

        // extra booking fee item OLD
        // if (bookingQuestion.visible) {
        //   if (bookingQuestion.conditionals.hasOwnProperty('extra-item')) {
        //     bookingQuestion.extraItem =
        //       bookingQuestion.conditionals['extra-item'];
        //     bookingQuestion.extraItemLabel =
        //       bookingQuestion.conditionals['extra-item-label'];

        //     if (bookingQuestion.answer) {
        //       let cost = bookingQuestion.options.filter(
        //         (option) => option.name == bookingQuestion.answer
        //       );
        //       const costVar =
        //         cost[0].price > 0
        //           ? cost[0].price / bookingQuestion.answer / 100
        //           : 0;
        //       this.costBreakDown.push({
        //         questionid: bookingQuestion.id,
        //         item: bookingQuestion.extraItemLabel,
        //         quantity: bookingQuestion.answer,
        //         cost: costVar,
        //       });
        //       this.datastoreService.triggerAddFees({
        //         questionid: bookingQuestion.id,
        //         item: bookingQuestion.extraItemLabel,
        //         quantity: bookingQuestion.answer,
        //         cost: costVar,
        //       });
        //     }
        //   }
        // }

        // extra booking fee item NEW
        console.log("Checking for extra item to add");
        if (bookingQuestion.visible) {
          this.addExtraBookingItemFee(bookingQuestion);
        }

        // set client data on booking details page
        // if (bookingQuestion.visible) {
        //   if (bookingQuestion.conditionals.hasOwnProperty('booker_first_name')) {
        //     this.datastoreService.booker_first_name = bookingQuestion.id;
        //   }
        //   if (bookingQuestion.conditionals.hasOwnProperty('booker_last_name')) {
        //     this.datastoreService.booker_last_name = bookingQuestion.id;
        //   }
        //   if (bookingQuestion.conditionals.hasOwnProperty('booker_email')) {
        //     this.datastoreService.booker_email = bookingQuestion.id;
        //   }
        //   if (bookingQuestion.conditionals.hasOwnProperty('booker_phone')) {
        //     this.datastoreService.booker_phone = bookingQuestion.id;
        //   }
        // }

        // if (bookingQuestion.conditionals.hasOwnProperty('continuebutton')) {
        //   // showContinueButton
        //   let conditionalQuestion = this.companyQuestionsForm.get(`${Object.keys(bookingQuestion.conditionals.continuebutton)[0]}`);
        //   console.log(conditionalQuestion);
        //   if (conditionalQuestion && conditionalQuestion.value != null) {
        //     if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
        //       if (Object.values(bookingQuestion.conditionals.continuebutton)[0][0] == "*") { // wildcard
        //         if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
        //           if (this.config["auto_select_service"]) {
        //             this.showContinueButton = true;
        //           } else {
        //             // filter services
        //             if (this.datastoreService.setService) {
        //               this.filteredServiceList = this.servicesList.filter(service => `${service.id}` == `${this.datastoreService.setService}`);
        //             } else {
        //               this.filteredServiceList = this.servicesList;
        //             }
        //             // this.showServices = true;
        //           }
        //         }
        //       } else {
        //         if (conditionalQuestion.value == Object.values(bookingQuestion.conditionals.continuebutton)[0][0]) {
        //           if (this.config["auto_select_service"]) {
        //             this.showContinueButton = true;
        //           } else {
        //             // filter services
        //             if (this.datastoreService.setService) {
        //               this.filteredServiceList = this.servicesList.filter(service => `${service.id}` == `${this.datastoreService.setService}`);
        //             } else {
        //               this.filteredServiceList = this.servicesList;
        //             }
        //             // this.showServices = true;
        //           }
        //         }
        //       }
        //     }
        //   }
        // }

        // slice booking questions off for first-n
        if (bookingQuestion.visible && !bookingQuestion.optionsRemoved) {
          if (
            bookingQuestion.conditionals.hasOwnProperty(
              'remove-options-customer'
            )
          ) {
            let firstN =
              bookingQuestion.conditionals['remove-options-customer'][
              'first-n'
              ];
            if (!this.datastoreService.adminJourney) {
              bookingQuestion.options = bookingQuestion.options.slice(firstN);
              bookingQuestion.optionsRemoved = true;
            }
          }
        }

        if (!this.datastoreService.adminJourney && admin_only) {
          bookingQuestion.visible = false;
        }

        if (!bookingQuestion.original_name) {
          bookingQuestion.original_name = bookingQuestion.name; // store old name
        }

        // if question name contains braces
        if (
          bookingQuestion.original_name &&
          /{.*?}/.test(bookingQuestion.original_name) // check if it has {placeholders}
        ) {
          bookingQuestion.name = bookingQuestion.original_name.replace(
            /{(.*?)}/g,
            (placeholder, refKey) => {
              // Look in bookingQuestions
              let refQuestion = bookingQuestions.find(
                (q) => q.question_reference === refKey && q.answer
              );

              // If not found, look in startQuestions
              if (!refQuestion) {
                const startQ = this.datastoreService.startQuestions.get(refKey);
                if (startQ && startQ.answer) {
                  return startQ.answer;
                }
              }

              // If found in bookingQuestions
              if (refQuestion && refQuestion.answer) {
                return refQuestion.answer;
              }

              // If no match, keep the original {placeholder}
              return placeholder;
            }
          );
        }

        if (!bookingQuestion.visible) {
          const conditionalQuestion = this.companyQuestionsForm.get(
            `${bookingQuestion.id}`
          );
          conditionalQuestion.reset();
          conditionalQuestion.clearValidators();
          conditionalQuestion.updateValueAndValidity();
        }
      } else {
        bookingQuestion.visible = true;
      }
    });
    */
  }

  evaluateORCondition(condition: string, answer: any): boolean {
    const parts = condition.split(' OR ').map(p => p.trim());

    if (Array.isArray(answer)) {
      return parts.some(part => answer.includes(part));
    } else {
      return parts.some(part => part === answer);
    }
  }


  // Function to evaluate custom condition
  evaluateCondition(condition, answer) {
    // Split the condition into individual parts
    const parts = condition.split(' and ');

    // Evaluate each part of the condition
    for (const part of parts) {
      // Split the part into operator and threshold
      let [operator, thresholdStr] = part.split(' ');
      const threshold = parseFloat(thresholdStr);

      // decode html entity
      operator = he.decode(operator);

      if (this.isValidDate(answer)) {
        answer = moment(answer).diff(moment(), 'days') + 1;
      }

      // Perform the comparison based on the operator
      switch (operator) {
        case '<':
          if (!(parseFloat(answer) < threshold)) {
            return false; // If any part is false, the entire condition is false
          }
          break;
        case '<=':
          if (!(parseFloat(answer) <= threshold)) {
            return false;
          }
          break;
        case '>':
          if (!(parseFloat(answer) > threshold)) {
            return false;
          }
          break;
        case '>=':
          if (!(parseFloat(answer) >= threshold)) {
            return false;
          }
          break;
        case '=':
          if (!(parseFloat(answer) === threshold)) {
            return false;
          }
          break;
        default:
          return false;
      }
    }

    // If all parts pass, return true
    return true;
  }

  validateQuestions(event, question) {
    // Extract the day, month, and year values from the inputs
    const dayInput = (
      document.getElementById(`${question.id}_d`) as HTMLInputElement
    )?.value;
    const monthInput = (
      document.getElementById(`${question.id}_m`) as HTMLInputElement
    )?.value;
    const yearInput = (
      document.getElementById(`${question.id}_y`) as HTMLInputElement
    )?.value;

    // Combine them into a single date string
    const day = dayInput?.padStart(2, '0'); // Ensure day is two digits
    const month = monthInput?.padStart(2, '0'); // Ensure month is two digits
    const year = yearInput; // Year doesn't need padding

    // Validate that the inputs are valid and combine into a date
    if (day && month && year) {
      this.companyQuestionsForm.controls[question.reference].markAsTouched();
      this.companyQuestionsForm.controls[question.reference].markAsDirty();
      const combinedDate = `${year}-${month}-${day}`; // Format: YYYY-MM-DD
      if (this.isValidDateQuestion(combinedDate)) {
        this.companyQuestionsForm.controls[question.reference].setValue(
          combinedDate
        );
      } else {
        console.error('Invalid date entered:', combinedDate);
        // question.selectedDate = null; // Clear selectedDate if invalid
      }
    } else {
      question.selectedDate = null; // Clear selectedDate if not all fields are filled
    }

    // this.calculateVisibility();
    this.onQuestionChange();
  }

  isValidDateQuestion(dateString: string): boolean {
    const date = new Date(dateString);
    return !isNaN(date.getTime()); // Check if the date is valid
  }

  updateRadio(form, question, answer) {
    form.controls[question].setValue(answer);
    if (question !== 'copyData') {
      this.onQuestionChange();
    } else {
      this.radioCopyChange();
    }
  }

  setAddress(event, question) {
    // set the address value on the form
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value; // This now gives you `option.id`
    this.companyQuestionsForm.controls[question.reference].setValue(
      selectedValue
    );
    console.log('Selected address set:', selectedValue);
    this.datastoreService.selectedAddress = selectedValue;
  }

  getAddress(question) {
    question.currently_searching = true;
    // Custom error handling for postcode
    try {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(async () => {
        const postcode: string = this.companyQuestionsForm.controls[
          'postcode_' + question.reference
        ].value.replace(/\s/g, '');
        if (postcode.length > 1) {
          //check postcode accepts regex before calling
          if (this.postcodeValidator.test(postcode)) {
            this.apiService.get(postcode).subscribe(
              (res) => {
                this.companyQuestionsForm.controls[`postcode_${question.id}`].setErrors({ invalid_address: false });
                const object: any = res;
                if (object.results) {
                  const addresses = object.results;
                  question.addresses = [];
                  if (addresses.length > 1) {
                    // If it matches up, push the addresses
                    addresses.forEach((item) => {
                      console.log(item);
                      // if (item.DPA) {
                      //   item.DPA.type = 'DPA';
                      //   question.addresses.push({ address: item.DPA });
                      // } else {
                      //   item.LPI.type = 'LPI';
                      //   question.addresses.push({ address: item.LPI });
                      // }
                      question.addresses.push({ address: item });
                    });
                  }
                }
                this.spinner.hide();
              },
              (err) => {
                console.log(err);
                this.spinner.hide();
              }
            );
          } else {
            this.companyQuestionsForm.controls[`postcode_${question.id}`].setErrors({ invalid_address: true });
          }
        }
      }, 500);
    } catch (error) {
      console.log(error);
    }
  }

  onFileChange(event, questionId) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form[questionId].setValue(file, { emitModelToViewChange: false });
      this.bookingQuestionsForm.patchValue({
        fileSource: file,
      });
    }
  }

  isValidDate(dateString: string): boolean {
    // Attempt to create a Date object from the dateString
    const date: Date = new Date(dateString);
    // Check if the created Date object is valid and its string representation matches the input
    return (
      date instanceof Date &&
      !isNaN(date.getTime()) &&
      date.toISOString().slice(0, 10) === dateString
    );
  }

  getAge(dateString) {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  // validate future dates
  futureDateValidator(control) {
    const currentDate = new Date();
    const inputDate = new Date(control.value);
    if (control.value) {
      if (inputDate > currentDate) {
        return { futureDate: true };
      }
      return null;
    } else {
      return null;
    }
  }

  // validate past dates
  pastDateValidator(control) {
    const currentDate = new Date();
    const inputDate = new Date(control.value);
    if (control.value) {
      if (inputDate < currentDate) {
        return { pastDate: true };
      }
      return null;
    } else {
      return null;
    }
  }

  async onSubmit() {
    this.spinner.show();
    this.submitted = true;
    this.alertService.clear();

    // Check if form is valid
    // console.log(this.customerDetailsForm.invalid || this.bookingQuestionsForm.invalid)
    // console.log(this.companyQuestionsForm);
    // Object.keys(this.companyQuestionsForm.controls).forEach((key) => {
    //   const control = this.companyQuestionsForm.controls[key];
    //   //clear postcode validation for postcode search as it will prevent submission on non-mandatory field
    //   if (key.startsWith("postcode_")) {
    //     control.setErrors(null);
    //   }
    // });

    // trigger form validation
    this.customerDetailsForm.markAllAsTouched();
    // this.companyQuestionsForm.markAllAsTouched();

    // trigger the validation on the customerDetailsForm
    this.customerQuestions.forEach((question) => {
      this.customerDetailsForm.controls[question.id].markAsTouched();
    });

    if (this.adminJourney) {
      if (
        this.customerDetailsForm.value.email_address_consent == false ||
        this.customerDetailsForm.value.contact_number_consent == false
      ) {
        this.scrollToTop();
        this.spinner.hide();
        this.alertService.warn(
          this.translateService.instant('FORM.VALIDATION_ERR_MSG')
        );
        return;
      }
    } else {
      this.customerDetailsForm.controls.email_address_consent.setValue(true);
      this.customerDetailsForm.controls.contact_number_consent.setValue(true);
      this.customerDetailsForm.controls.email_address_consent.setErrors(null);
      this.customerDetailsForm.controls.contact_number_consent.setErrors(null);
    }

    if (this.customerDetailsForm.invalid || this.companyQuestionsForm.invalid) {
      this.scrollToTop();
      this.spinner.hide();
      this.alertService.warn(
        this.translateService.instant('FORM.VALIDATION_ERR_MSG')
      );
      return;
    }

    // SUP-2485: enforce required fields in the schema form before continuing.
    if (this.formBuilderRef && !this.formBuilderRef.validateAndReveal()) {
      this.scrollToTop();
      this.spinner.hide();
      this.alertService.warn(
        this.translateService.instant('FORM.VALIDATION_ERR_MSG')
      );
      return;
    }

    // var currentDate = new Date(this.slot.start);
    // await this.apiService.checkForDoubleBooking(
    //   this.selectedDepartment,
    //   currentDate,
    //   this.customerDetailsForm.value.email_address ? this.customerDetailsForm.value.email_address : null,
    //   this.customerDetailsForm.value.mobile_number ? this.customerDetailsForm.value.mobile_number : null,
    // ).then((res: []) => {
    //   // res = array of unavailable times
    //   this.unavailableTimes = res

    this.completeBooking();
    // })
  }


  // Scroll to the top of the page
  scrollToTop() {
    const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
    window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
  }

  // Number input text validation, keycode 8 is backspacev
  keyPressNumberField(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
    const inputElement = event.target as HTMLInputElement;
    if (
      (event.keyCode != 8 && !pattern.test(inputChar)) ||
      inputElement.value.length >= 15
    ) {
      event.preventDefault();
    }
  }

  calculateCertificates(question) {
    const optionChosen = question.options.find(
      (x) =>
        x.name.toString() === this.bookingForm[question.id].value.toString()
    );
    this.costBreakDown.push({
      item: 'Certificates',
      quantity: optionChosen.name,
      cost: optionChosen.price,
    });

    this.datastoreService.costBreakDown = this.costBreakDown;
  }

  addQuestionsToForm(questions) {
    this.companyQuestions = [];
    // this.companyQuestionsForm = this.datastoreService.companyQuestionsForm;
    for (let index = 0; index < questions.length; index++) {
      const question = questions[index];
      question.visible = false;
      question.reference = question.id;
      if (!question.admin_only) {
        if (!question.settings.hasOwnProperty('conditional_question')) {
          question.visible = false; // default hidden all
        }

        const questionControl = question.id;

        if (!question['help_text']) {
          // question without any config
          question.conditionals = {
            page: this.router.url, // show on current page
          };
        } else {
          question.conditionals = JSON.parse(question['help_text']);
        }

        if (question.conditionals.page == this.router.url.replace('/', '')) {
          this.companyQuestions.push(question);

          let validators = [];

          // required validator
          if (question.required) {
            validators.push(Validators.required);
          }
          if (
            question.conditionals['address_lookup'] ||
            question.conditionals['address_lookup_multi_line']
          ) {
            this.companyQuestionsForm.addControl(
              'postcode_' + questionControl,
              new UntypedFormControl('', validators)
            );
          }
          if (
            question.detail_type == 'check' ||
            question.detail_type == 'check-price'
          ) {
            this.companyQuestionsForm.addControl(
              questionControl,
              new UntypedFormControl('', Validators.requiredTrue)
            );
          } else {
            this.companyQuestionsForm.addControl(
              questionControl,
              new UntypedFormControl('', validators)
            );
          }

          // if we can find that question on datastore, we can set value back to what we have saved
          if (this.datastoreService.companyAnswers) {
            const questionFound = this.datastoreService.companyAnswers.get(
              `${question.id}`
            );
            if (questionFound) {
              this.companyQuestionsForm.controls[question.id].setValue(
                questionFound.value
              );
              this.companyQuestionsForm.controls[question.id].patchValue(
                questionFound.value
              );
            }
          }

          // once the controls are added we can set the default values
          if (
            question.detail_type == 'select' ||
            question.detail_type == 'select-price'
          ) {
            const defaultOption = question.options.find(
              (option) => option.is_default
            );
            if (defaultOption) {
              this.companyQuestionsForm.controls[question.id].setValue(
                defaultOption.name
              );
              this.companyQuestionsForm.controls[question.id].patchValue(
                defaultOption.name
              );
              this.calculateCertificates(question);
            }
          }
        }
      }
    }
    this.onQuestionChange();
  }

  selectSuggestion(selectedUPRN: any, question: any): void {
    console.log('Selected UPRN:', selectedUPRN);
    const suggestion = question.addresses.find(
      (option) => option.address.UPRN === selectedUPRN
    );
    question.addresses = [];
    question.currently_searching = false;
    if (question.address_lookup_multi_line) {
      console.log(suggestion);
      const address = suggestion['address'];
      this.datastoreService.selectedAddress = suggestion['address'].full_address;
      console.log(this.datastoreService.selectedAddress);
      const multiline = question.address_lookup_multi_line_to;
      // if (address.type == 'DPA') {
      //   const keys = ['BUILDING_NUMBER', 'BUILDING_NAME', 'ORGANISATION_NAME'];
      //   const selectedValue = keys.find((key) => address[key] !== undefined)
      //     ? address[keys.find((key) => address[key] !== undefined)]
      //     : null;
      //   this.companyQuestionsForm.controls[multiline[0]].setValue(
      //     `${selectedValue ?? ''} ${address?.THOROUGHFARE_NAME ?? ''}`
      //   ); // address 1
      //   this.companyQuestionsForm.controls[multiline[1]].setValue(
      //     address?.DEPENDENT_LOCALITY ?? ''
      //   ); // address 2
      //   this.companyQuestionsForm.controls[multiline[2]].setValue(
      //     address?.POST_TOWN ?? ''
      //   ); // address 3
      //   this.companyQuestionsForm.controls[multiline[3]].setValue(
      //     address?.LOCAL_CUSTODIAN_CODE_DESCRIPTION ?? ''
      //   ); // address 4
      //   this.companyQuestionsForm.controls[multiline[4]].setValue(
      //     address?.POSTCODE ?? ''
      //   ); // address 5
      // } else {
      //   this.companyQuestionsForm.controls[multiline[0]].setValue(
      //     `${address.PAO_START_NUMBER ?? ''} ${address.STREET_DESCRIPTION ?? ''
      //     } ${address.SAO_TEXT ?? ''}`
      //   ); // address 1
      //   this.companyQuestionsForm.controls[multiline[1]].setValue(
      //     `${address.LOCALITY_NAME ?? ''} ${address.PAO_TEXT ?? ''}`
      //   ); // address 2
      //   this.companyQuestionsForm.controls[multiline[2]].setValue(
      //     `${address.TOWN_NAME ?? ''}`
      //   ); // address 3
      //   this.companyQuestionsForm.controls[multiline[3]].setValue(
      //     `${address.ADMINISTRATIVE_AREA ?? ''}`
      //   ); // address 4
      //   this.companyQuestionsForm.controls[multiline[4]].setValue(
      //     `${address.POSTCODE ?? ''}`
      //   ); // address 5
      // }
      this.companyQuestionsForm.controls[multiline[0]].setValue(
        `${address.address_line_1 ?? ''}`
      ); // address 1
      this.companyQuestionsForm.controls[multiline[1]].setValue(
        `${address.address_line_2 ?? ''}`
      ); // address 2
      this.companyQuestionsForm.controls[multiline[2]].setValue(
        `${address.town ?? ''}`
      ); // address 3
      this.companyQuestionsForm.controls[multiline[3]].setValue(
        `${address.county ?? ''}`
      ); // address 4
      this.companyQuestionsForm.controls[multiline[4]].setValue(
        `${address.postcode ?? ''}`
      ); // address 5
      this.onQuestionChange();
    } else {
      // code for single line addresses can go here
      this.companyQuestionsForm.controls[question.id].setValue(
        suggestion['pretty_name']
      );
      console.log('Selected address set:', suggestion['pretty_name']);
      this.datastoreService.selectedAddress = suggestion['pretty_name'];
      this.companyQuestionsForm.controls[question.id].updateValueAndValidity();
      this.onQuestionChange();
    }
  }

  async addExtraBookingItemFee(bookingQuestion: any) {
    if (bookingQuestion.conditionals.hasOwnProperty('extra-item')) {
      bookingQuestion.extraItem = bookingQuestion.conditionals['extra-item'];
      bookingQuestion.extraItemLabel =
        bookingQuestion.conditionals['extra-item-label'];

      // let cost;
      // let costVar;

      // if (bookingQuestion.answer && bookingQuestion.detail_type === 'select') {
      //   cost = bookingQuestion.options.filter(
      //     (option) => option.name == bookingQuestion.answer
      //   );
      //   costVar =
      //     cost[0].price > 0 ? cost[0].price / bookingQuestion.answer / 100 : 0;
      // } else if (
      //   bookingQuestion.answer &&
      //   bookingQuestion.detail_type === 'number'
      // ) {
      //   costVar = bookingQuestion.price / bookingQuestion.answer / 100;
      // }

      // console.log(`addExtraBookingItemFee:`);
      // console.log(bookingQuestion);

      if (bookingQuestion.answer == null) {
        bookingQuestion.answer = 1; // default to 1 if no answer
      }

      // let itemProps: any;
      // if (this.feeItemCache.hasOwnProperty(bookingQuestion.extraItem)) {
      //   console.log(`Using cached fee item for ${bookingQuestion.extraItem}`);
      //   itemProps = this.feeItemCache[bookingQuestion.extraItem];
      // } else {
      const itemProps: any = await this.apiService.getExtraItemProperties(
        bookingQuestion.extraItem,
        this.selectedDepartment.id,
        this.selectedService.id
      );
      //   this.feeItemCache[bookingQuestion.extraItem] = itemProps;
      // }

      if (itemProps) {
        bookingQuestion.current_price = itemProps.item_price;
      }

      this.costBreakDown.push({
        questionid: bookingQuestion.id,
        item: bookingQuestion.extraItemLabel,
        quantity: bookingQuestion.answer,
        cost: bookingQuestion.current_price || 0,
      });

      this.datastoreService.triggerAddFees({
        questionid: bookingQuestion.id,
        item: bookingQuestion.extraItemLabel,
        quantity: bookingQuestion.answer,
        cost: bookingQuestion.current_price || 0,
      });
    }
  }

  async completeBooking() {
    // this.bookingQuestionsForm.controls.contact(this.datastoreService.startQuestions)
    this.datastoreService.bookingForm = this.bookingQuestionsForm;
    this.datastoreService.companyAnswers = this.companyQuestionsForm;
    this.datastoreService.customerDetailsForm = this.customerDetailsForm;
    console.log(this.datastoreService);
    this.spinner.hide();

    this.router.navigate(['/summary']);
  }

  updateAnswers(event: any) {
    console.log('updateAnswers called with event:', event);
    this.commonFunctions.updateAnswers(event);
  }

  storeSchema(schema: any) {
    this.commonFunctions.storeSchema(schema);
  }
}
